import React, { useState } from "react";
import { Form, Row, Col, Image, Button } from "react-bootstrap";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  IconButton,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Toggle } from "../../../superAdminReusable/reusableSuperAdminButton/Toggle";

const OfflineEvent = () => {
  //state
  const [checked, setChecked] = useState(false);
  const [FloorsSection, setFloorsSection] = useState(false);
  const [file, setFile] = useState(null);
  const [Video, setVideo] = useState(null);
  const [selectedTab, setSelectedTab] = useState(1);
  const handleTab = (e) => {
    setSelectedTab(e);
  };
  const toggleFunction = (e) => {
    setChecked({ checked: !checked.checked });
  };
  const uploadImage = (e) => {
    setFile(URL.createObjectURL(e.target.files[0]));
  };
  const uploadVideo = (e) => {
    setVideo(URL.createObjectURL(e.target.files[0]));
  };
  const [state, setState] = useState({
    minAge: "",
    floorNumberSeatingArea: "",
    sectionNameNumber: "",
  });
  const selecthandleChange = (e) => {
    setState({ [e.target.name]: e.target.value });
  };
  const handleToggleFloorsSection = (e) => {
    setFloorsSection({
      FloorsSection: !FloorsSection.FloorsSection,
    });
  };

  return (
    <React.Fragment>
      <div className="d-flex align-items-center">
        <Button
          variant="link"
          className={`px-0 mr-4 text-grayLink f12-500 ${
            selectedTab === 1 ? "active" : ""
          }`}
        >
          General Information
        </Button>
        <Button
          variant="link"
          className={`px-0 mr-4 text-grayLink f12-500 ${
            selectedTab === 2 ? "active" : ""
          }`}
        >
          RSVP
        </Button>
        <Button
          variant="link"
          className={`px-0 mr-4 text-grayLink f12-500 ${
            selectedTab === 3 ? "active" : ""
          }`}
        >
          Ticket Booking
        </Button>
        <Button
          variant="link"
          className={`px-0 mr-4 text-grayLink f12-500 ${
            selectedTab === 4 ? "active" : ""
          }`}
        >
          Seating
        </Button>
      </div>
      {selectedTab === 1 && (
        <Form>
          <Row className="pt-4">
            <Col lg={8}>
              <Form.Group>
                <TextField
                  label="Event Name"
                  type="text"
                  variant="outlined"
                  className="w-100"
                />
              </Form.Group>
              <Form.Group>
                <TextField
                  label="Description"
                  type="text"
                  multiline
                  rows="5"
                  variant="outlined"
                  className="w-100"
                />
              </Form.Group>
              <Row className="pb-4">
                <Col lg={6}>
                  <div className="f12-400">
                    (Fill out the details, event are used offline)
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="d-flex align-items-start">
                    <Toggle
                      checked={checked.checked}
                      toggleFunction={toggleFunction}
                    />
                    <div className="pl-2">
                      <div className="f12-500 mb-2">
                        Make this Event Primary
                      </div>
                      <div className="f10-400">
                        (Note you can make only one Offer primary, by making
                        this offer primary it will remove primary from other
                        active offers)
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col lg={12}>
              <hr />

              <div className="f16-500 py-1">Allow Kids?</div>
              <div className="f10-400 pb-4">
                (This may be relevant if you are a Bar and Night Club with min
                age to enter, you may still have to check the ID for the
                entrants)
              </div>
              <Row className="align-items-center pb-3">
                <Col md={3}>
                  <div className="f14-400 text-dark">Kids Allowed</div>
                </Col>
                <Col md={9}>
                  <div className="d-flex align-items-center">
                    <div className="f12-400 mr-2">No</div>
                    <Toggle
                      checked={checked.checked}
                      toggleFunction={toggleFunction}
                    />
                    <div className="f12-400 ml-2">Yes</div>
                  </div>
                </Col>
              </Row>
              <Row className="align-items-center pb-3">
                <Col md={3}>
                  <div className="f14-400 text-dark">Min Age for Entry</div>
                </Col>
                <Col md={9}>
                  <FormControl variant="outlined" className={"w134"}>
                    <Select
                      value={state.minAge}
                      onChange={selecthandleChange}
                      inputProps={{
                        name: "minAge",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value={"18"}>18</option>
                      <option value={"20"}>20</option>
                    </Select>
                  </FormControl>
                </Col>
              </Row>
              <hr className="mb-5" />
              <Row className="pb-4">
                <Col md={3}>
                  <TextField
                    label="Event Tags"
                    variant="outlined"
                    className="w-100"
                  ></TextField>
                </Col>
                <Col>
                  <Button
                    variant="link"
                    className="d-flex align-items-center p-0 mt-2"
                  >
                    <Image
                      src={require("../../../../../assets/images/UserManagement/delete-gray.svg")}
                      alt="Delete"
                      title="Delete"
                      className="w-20px"
                    />
                    <span className="ml-2 f12-500 opacity5">Delete</span>
                  </Button>
                </Col>
              </Row>
              <Button
                variant="link"
                className="d-flex align-items-center p-0 mb-4"
              >
                <Image
                  src={require("../../../../../assets/images/UserManagement/add-blue.svg")}
                  alt="add"
                  title="add"
                  className="w-20px"
                />
                <span className="ml-2 f12-500 text-blue">Add</span>
              </Button>
              <Row className="pb-4 align-items-center">
                <Col md={3} xl={2}>
                  <TextField
                    label="Start Date"
                    variant="outlined"
                    type="date"
                    className="w-100"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Col>
                <Col md={3} xl={2}>
                  <TextField
                    label="Start Time"
                    variant="outlined"
                    type="time"
                    className="w-100"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Col>
                <Col md={3} xl={2}>
                  <TextField
                    label="End Date"
                    variant="outlined"
                    type="date"
                    className="w-100"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Col>
                <Col md={3} xl={2}>
                  <TextField
                    label="End Time"
                    variant="outlined"
                    type="time"
                    className="w-100"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Col>
              </Row>
              <Row className="pb-4 align-items-center">
                <Col md={4} lg={4}>
                  <Form.Group>
                    <TextField
                      label="Coupon Code"
                      type="text"
                      variant="outlined"
                      className="w-100"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col lg={8}>
                  <Form.Group>
                    <TextField
                      label="Venue/Adress/Location"
                      type="text"
                      multiline
                      rows="5"
                      variant="outlined"
                      className="w-100"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <hr />
              <Form.Group className="py-4">
                <Form.Label className="f14-500 mb-3">Add Photos</Form.Label>
                <div className="d-flex flex-wrap">
                  <div className="enUploadBox">
                    <Image
                      src={require("../../../../../assets/images/UserManagement/uploadImg.svg")}
                      alt="uploadImg"
                      title="uploadImg"
                      fluid
                    />
                    <input
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      onChange={uploadImage}
                    />
                  </div>
                  {file && (
                    <div className="enIconUploaded">
                      <button
                        type="button"
                        className="enCloseButton"
                        onClick={() => setFile(null)}
                      >
                        <Image
                          src={require("../../../../../assets/images/UserManagement/en_close.svg")}
                          alt="uploadImg"
                          title="uploadImg"
                          fluid
                        />
                      </button>
                      <Image
                        src={file}
                        alt="icon"
                        title="icon"
                        className=""
                        fluid
                      />
                    </div>
                  )}
                </div>
                <div className="pt-2 f12-400">
                  (You can upload only 1 pic per offer 700 x 420 pixels)
                </div>
              </Form.Group>
              <Form.Group className="pb-4">
                <Form.Label className="f14-500 mb-3">Add Video</Form.Label>
                <div className="d-flex flex-wrap">
                  <div className="enUploadBox">
                    <Image
                      src={require("../../../../../assets/images/UserManagement/uploadImg.svg")}
                      alt="uploadImg"
                      title="uploadImg"
                      fluid
                    />
                    <input type="file" accept=".mp4" onChange={uploadVideo} />
                  </div>
                  {Video && (
                    <div className="enIconUploaded">
                      <button
                        type="button"
                        className="enCloseButton"
                        onClick={() => setVideo(null)}
                      >
                        <Image
                          src={require("../../../../../assets/images/UserManagement/en_close.svg")}
                          alt="uploadImg"
                          title="uploadImg"
                          fluid
                        />
                      </button>
                      <video
                        width="100%"
                        height="100%"
                        controls
                        src={Video}
                        type="video/mp4"
                      />
                    </div>
                  )}
                </div>
                <div className="pt-2 f12-400">
                  (You can upload only 1 pic per offer 700 x 420 pixels)
                </div>
              </Form.Group>
              <Row>
                <Col lg={8}>
                  <Form.Group>
                    <TextField
                      label="Terms and Conditions"
                      type="text"
                      multiline
                      rows="5"
                      variant="outlined"
                      className="w-100"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <div className="py-4 d-flex align-items-center">
                <Button
                  variant="outline-secondary"
                  className="btn-lg mr-4 px-5 btn150px"
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  className="btn-lg px-5 btn150px"
                  onClick={() => handleTab(2)}
                >
                  Next
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      )}
      {selectedTab === 2 && (
        <Form>
          <Row className="pt-4">
            <Col lg={12}>
              <Row className="align-items-center pb-3">
                <Col md={3}>
                  <div className="f16-500 text-dark">Auto Accept</div>
                </Col>
                <Col md={9}>
                  <div className="d-flex align-items-center">
                    <div className="f12-400 mr-2">No</div>
                    <Toggle
                      checked={checked.checked}
                      toggleFunction={toggleFunction}
                    />
                    <div className="f12-400 ml-2">Yes</div>
                  </div>
                </Col>
              </Row>
              <Row className="pb-4">
                <Col md={3}>
                  <TextField
                    label="Maximum Number of Guests"
                    variant="outlined"
                    className="w-100"
                  ></TextField>
                </Col>
              </Row>
              <Row className="pb-4">
                <Col md={2}>
                  <TextField
                    label="Buffer %"
                    variant="outlined"
                    className="w-100"
                  ></TextField>
                </Col>
              </Row>
              <div className="py-4 d-flex align-items-center">
                <Button
                  variant="outline-secondary"
                  className="btn-lg mr-4 px-5 btn150px"
                  onClick={() => handleTab(1)}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  className="btn-lg px-5 btn150px"
                  onClick={() => handleTab(3)}
                >
                  Next
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      )}
      {selectedTab === 3 && (
        <Form>
          <Row className="py-4">
            <Col md={12} lg={6}>
              <Form.Group className="pb-4">
                <TextField
                  label="Ticket Name"
                  variant="outlined"
                  className="w-100"
                />
              </Form.Group>
              <div className="d-flex align-items-center pb-4">
                <label className="enRadioWithText f16-500 mr-4">
                  Paid
                  <input type="radio" name="CouponDiscountType" />
                  <span class="checkmark"></span>
                </label>
                <label className="enRadioWithText f16-500 mr-4">
                  Free
                  <input type="radio" name="CouponDiscountType" />
                  <span class="checkmark"></span>
                </label>
              </div>
              <Row>
                <Col md={6}>
                  <Form.Group className="pb-4">
                    <TextField
                      label="Adult Price"
                      variant="outlined"
                      className="w-100"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="pb-4">
                    <TextField
                      label="Child Price"
                      variant="outlined"
                      className="w-100"
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className="pb-4">
                    <TextField
                      label="Total Quantity"
                      variant="outlined"
                      className="w-100"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="pb-4">
                    <TextField
                      label="Minimum people per booking"
                      variant="outlined"
                      className="w-100"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="pb-4">
                    <TextField
                      label="Maximum people per booking"
                      variant="outlined"
                      className="w-100"
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className="pb-4">
                    <TextField
                      label="Ticket Description"
                      variant="outlined"
                      multiline
                      rows="4"
                      className="w-100"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Col>
          </Row>

          <div className="py-4 d-flex align-items-center">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5 btn150px"
              onClick={() => handleTab(2)}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5 btn150px"
              onClick={() => handleTab(4)}
            >
              Next
            </Button>
          </div>
        </Form>
      )}
      {selectedTab === 4 && (
        <Form>
          <div className="f16-500 pb-4">Assign Seating area</div>
          <Row>
            <Col md={3}>
              <Form.Group className="pb-4">
                <FormControl variant="outlined" className="w-100">
                  <InputLabel htmlFor="outlined-floorNumberSeatingArea">
                    Floor Number / Seating Area
                  </InputLabel>
                  <Select
                    value={state.floorNumberSeatingArea}
                    onChange={(e) => selecthandleChange(e)}
                    label="Floor Number / Seating Area"
                    inputProps={{
                      name: "floorNumberSeatingArea",
                      id: "outlined-floorNumberSeatingArea",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <option value={"1"}>1</option>
                  </Select>
                </FormControl>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="pb-4">
                <FormControl variant="outlined" className="w-100">
                  <InputLabel htmlFor="outlined-sectionNameNumber">
                    Section Name/Number
                  </InputLabel>
                  <Select
                    value={state.sectionNameNumber}
                    onChange={(e) => selecthandleChange(e)}
                    label="Section Name/Number"
                    inputProps={{
                      name: "sectionNameNumber",
                      id: "outlined-sectionNameNumber",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <option value={"13A"}>13 A</option>
                    <option value={"13B"}>13 B</option>
                  </Select>
                </FormControl>
              </Form.Group>
            </Col>
            <Col md={4}>
              <div className="d-flex align-items-center">
                <Button
                  variant="link"
                  className="f16-400 d-flex align-items-center mr-3"
                >
                  <Image
                    src={require("../../../../../assets/images/UserManagement/Delete.svg")}
                    alt="Delete"
                    title="Delete"
                    className="w-20px"
                  />
                  <span className="pl-2">Delete</span>
                </Button>
                <Button
                  variant="link"
                  className="f16-400 d-flex align-items-center"
                >
                  <Image
                    src={require("../../../../../assets/images/UserManagement/eye.svg")}
                    alt="Delete"
                    title="Delete"
                    className="w-20px"
                  />
                  <span className="pl-2">View</span>
                </Button>
              </div>
            </Col>
          </Row>
          <Button variant="link" className="d-flex align-items-center p-0 mb-4">
            <Image
              src={require("../../../../../assets/images/UserManagement/add-blue.svg")}
              alt="add"
              title="add"
              className="w-20px"
            />
            <span className="ml-2 f12-500 text-blue">
              Assign another Floor and Section details
            </span>
          </Button>
          <hr />
          <div>
            <Button
              variant="link"
              className="d-flex align-items-center text-red p-0 mb-4"
              onClick={handleToggleFloorsSection}
            >
              <span className="f12-500 text-red">Hide Floors and Sections</span>
              <KeyboardArrowDownIcon />
            </Button>
          </div>
          {FloorsSection.FloorsSection && (
            <React.Fragment>
              <Row className="align-items-center">
                <Col md={3}>
                  <div className="f20-500 py-3">Floor</div>
                </Col>
                <Col md={3}>
                  <div className="f20-500 py-3">Section</div>
                </Col>
              </Row>
              <Row className="align-items-center">
                <Col md={3}>
                  <div className="f18-400 py-3">First Floor</div>
                </Col>
                <Col md={3}>
                  <div className="f18-400 py-3">13A</div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <IconButton className="mr-2">
                      <Image
                        src={require("../../../../../assets/images/UserManagement/editBlue.svg")}
                        alt="add"
                        title="add"
                        className="w-20px"
                      />
                    </IconButton>
                    <IconButton>
                      <Image
                        src={require("../../../../../assets/images/UserManagement/delete-gray.svg")}
                        alt="add"
                        title="add"
                        className="w-20px"
                      />
                    </IconButton>
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          )}
          <div className="py-4 d-flex align-items-center">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5 btn150px"
              onClick={() => handleTab(3)}
            >
              Cancel
            </Button>
            <Button variant="danger" className="btn-lg px-5 btn150px">
              Next
            </Button>
          </div>
        </Form>
      )}
    </React.Fragment>
  );
};
export default OfflineEvent;
